<template>
  <div v-if="promoCodesActive" class="mx-1 mt-3">
    <!--applied: code + what it saves-->
    <div
      v-if="appliedPromotion"
      class="d-flex align-center promo-applied px-3 py-2"
    >
      <v-icon color="success" class="mr-2">mdi-ticket-percent</v-icon>
      <div class="flex-grow-1">
        <div class="font-weight-bold success--text">
          {{ appliedPromotion.code }}
        </div>
        <div v-if="appliedPromotion.description" class="caption grey--text">
          {{ appliedPromotion.description }}
        </div>
      </div>
      <strong v-if="promoDiscountAmount > 0" class="success--text mr-1">
        -{{ promoDiscountAmount | currency }}
      </strong>
      <v-btn icon small color="error" @click="confirmRemove">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <!--collapsed trigger-->
    <v-btn
      v-else-if="!expanded"
      block
      text
      color="accent"
      class="text-capitalize justify-start px-2"
      @click="expanded = true"
    >
      <v-icon class="mr-2">mdi-ticket-percent-outline</v-icon>
      {{ $t("generic.lang_havePromoCode") }}
      <v-spacer />
      <v-icon small>mdi-chevron-right</v-icon>
    </v-btn>

    <!--input-->
    <v-text-field
      v-else
      v-model="code"
      :placeholder="$t('generic.lang_promoCode')"
      :disabled="promoChecking"
      class="rounded-lg promo-input"
      outlined
      rounded
      dense
      hide-details
      autofocus
      @keyup.enter="apply"
    >
      <template v-slot:append>
        <v-btn
          v-if="canScan"
          icon
          small
          color="accent"
          :disabled="promoChecking"
          @click="scanning = true"
        >
          <v-icon>mdi-qrcode-scan</v-icon>
        </v-btn>
        <v-btn
          depressed
          small
          color="accent"
          class="rounded-lg ml-1"
          :disabled="!code || promoChecking"
          :loading="promoChecking"
          @click="apply"
        >
          {{ $t("generic.lang_apply") }}
        </v-btn>
      </template>
    </v-text-field>

    <promo-code-scan-dialog v-model="scanning" @scanned="onScanned" />
    <promo-target-dialog v-model="targetFlow" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import promoCode from "@/mixins/promoCode";
import PromoCodeScanDialog from "./PromoCodeScanDialog";
import PromoTargetDialog from "./PromoTargetDialog";

export default {
  name: "PromoCodeRow",

  components: { PromoCodeScanDialog, PromoTargetDialog },

  mixins: [promoCode],

  data() {
    return {
      code: null,
      expanded: false,
      scanning: false,
      targetFlow: null
    };
  },

  computed: {
    ...createNamespacedHelpers("Order").mapGetters([
      "appliedPromotion",
      "promoDiscountAmount",
      "promoNotice"
    ]),

    canScan() {
      return !!window.navigator.mediaDevices;
    }
  },

  watch: {
    // reconcile dropped the promo, tell the customer which condition broke
    promoNotice(notice) {
      if (!notice || !notice.rules) return;

      this.promoInfo(this.promoConditionMessage(notice, notice.rules));
      this.$store.commit("Order/clearPromoNotice");
    }
  },

  methods: {
    async apply() {
      if (!this.code || this.promoChecking) return;

      const { applied, targetFlow } = await this.redeemPromoCode(this.code);

      if (targetFlow) {
        this.reset();
        this.targetFlow = targetFlow;
        return;
      }
      if (applied) this.reset();
    },

    onScanned(value) {
      this.scanning = false;
      this.code = value;
      this.apply();
    },

    confirmRemove() {
      this.$swal({
        text: this.$t("generic.lang_promoRemoveConfirm"),
        icon: "warning",
        buttons: [this.$t("generic.lang_cancel"), this.$t("generic.lang_yes")],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) this.removePromoCode();
      });
    },

    reset() {
      this.code = null;
      this.expanded = false;
    }
  }
};
</script>

<style scoped>
.promo-applied {
  border: 1px solid var(--v-success-base);
  border-radius: 8px;
}

.promo-input ::v-deep input {
  text-transform: uppercase;
}
</style>
